import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';

import { adminPageNames } from '../../shared/adminPageNames';

export const sharedSelectors = getSelectors(adminPageNames.LEGAL_ENTITIES);

export const enabledFlagOptionsSelector = createSelector(
  state => state.administration.legalEntitySettings.enabledFlagValues,
  enabledFlagValues => enabledFlagValues.map(({ name, value }) => ({ label: name, value }))
);

export const usTaxTypeOptionsSelector = createSelector(
  state => state.administration.legalEntitySettings.usTaxTypeValues,
  usTaxTypeValues => usTaxTypeValues.map(({ value }) => ({ label: value, value }))
);

export const localTaxTypeOptionsSelector = createSelector(
  state => state.administration.legalEntitySettings.localTaxTypeValues,
  localTaxTypeValues => localTaxTypeValues.map(({ value }) => ({ label: value, value }))
);

export const countryCodeOptionsSelector = createSelector(
  state => state.administration.legalEntitySettings.countryCodeValues,
  countryCodeValues => countryCodeValues.map(({ countryCode }) =>
    ({ label: countryCode, value: countryCode }))
);

export const branchOptionsSelector = createSelector(
  state => state.administration.legalEntitySettings.branchValues,
  branchValues => branchValues.map(({ name, value }) => ({ label: name, value }))
);

export const sourceOptionsSelector = state => state.administration.legalEntitySettings.sourceOptions;

export const isFetchingInitialDataForModalSelector = state =>
  state.administration[adminPageNames.LEGAL_ENTITIES].isFetchingInitialDataForModal;

export const legalEntityOptionsSelector = createSelector(
  state => state.administration.legalEntitySettings.legalEntities,
  legalEntities => legalEntities.map(({
    legalEntity,
    leDescription,
    countryCode,
  }) => ({
    label: leDescription,
    value: legalEntity,
    countryCode,
  }))
);
